import compose from 'lodash/fp/compose';
import { firestoreAction } from 'vuexfire';

import { canAdd, canUpdate, paginate } from '../plugins';
import { db } from '../../firebase';
import PluggableModule from '../pluggable';
import dailyChallengeApis from '../../firebase/dailyChallenges';

const dailyChallenges = new PluggableModule('daily_challenge');

const ucName = dailyChallenges.name.toUpperCase();
const GET_TYPEFORM_INFO_INIT = `${ucName}_GET_TYPEFORM_INFO_INIT`;
const GET_TYPEFORM_INFO_DONE = `${ucName}_GET_TYPEFORM_INFO_DONE`;
const LOAD_USER_DATA_INIT = `${ucName}_LOAD_USER_DATA_INIT`;
const LOAD_USER_DATA_DONE = `${ucName}_LOAD_USER_DATA_DONE`;
const LOAD_USER_DATA_ERROR = `${ucName}_LOAD_USER_DATA_ERROR`;

dailyChallenges.extend({
  namespaced: true,
  state: {
    typeformInfoLoading: false,
    typeformInfo: null,
    userDataLoading: false,
    userData: [],
    userDataError: null
  },
  mutations: {
    [GET_TYPEFORM_INFO_INIT](state) {
      state.typeformInfoLoading = true;
      state.typeformInfo = null;
    },
    [GET_TYPEFORM_INFO_DONE](state, data) {
      state.typeformInfoLoading = false;
      state.typeformInfo = data;
    },
    [LOAD_USER_DATA_INIT](state) {
      state.userDataLoading = true;
    },
    [LOAD_USER_DATA_DONE](state) {
      state.userDataLoading = false;
    },
    [LOAD_USER_DATA_ERROR](state, error) {
      state.userDataLoading = false;
      state.userDataError = error;
    }
  },
  actions: {
    async getTypeformInfo({ commit }, formId) {
      try {
        commit(GET_TYPEFORM_INFO_INIT);
        commit(
          GET_TYPEFORM_INFO_DONE,
          formId ? await dailyChallengeApis.getTypeformInfo(formId) : null
        );
      } catch (error) {
        commit(GET_TYPEFORM_INFO_DONE, null);
        throw error;
      }
    },
    bindRef: firestoreAction(async ({ bindFirestoreRef }, ref) => {
      await bindFirestoreRef('userData', ref, { maxRefDepth: 0 });
    }),
    async loadUserData({ commit, dispatch }, { userId, fromDate, toDate }) {
      commit(LOAD_USER_DATA_INIT);
      try {
        await dispatch(
          'bindRef',
          db
            .collectionGroup('dailyChallengeAttempts')
            .where('user', '==', db.collection('users').doc(userId))
            .where('date', '>=', fromDate)
            .where('date', '<', toDate)
        );
        commit(LOAD_USER_DATA_DONE);
      } catch (e) {
        commit(LOAD_USER_DATA_ERROR, e);
      }
    }
  }
});

const hop = compose(
  canAdd(dailyChallengeApis.add),
  canUpdate(),
  paginate('dailyChallenges')
);

export default hop(dailyChallenges);
